@if (visible()) {
<div @fadeIn (click)="scrollToTop()" [ngClass]="isNewsCaroulselPage ? 'footer-fix-tablet-news-carousel' : 'footer-fix-tablet-no-news-carousel'" 
  id="scroll-top-button"
  class="absolute right-4 bottom-4 md:right-12 w-12 h-12 md:w-20 md:h-20 bg-black opacity-50 cursor-pointer z-40">
  <mat-icon class="text-white text-7xl md:text-[80px]
  min-h-[50px] min-w-[50px] md:min-h-[80px] md:min-w-[80px]" svgIcon="core:keyboard_arrow_up"></mat-icon>
  </div>
}
